"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _constants = require("../constants");
var _constants2 = require("./constants");
var _Stack = _interopRequireDefault(require("./Stack.style"));
const _excluded = ["className", "size", "horizontal", "fullWidth", "fullHeight", "divider", "alignItems", "justifyContent", "children", "forwardRef", "classes", "dataTestId"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const StyledStack = (0, _reactJss.default)(_Stack.default)(_ref => {
  let {
      className,
      size,
      horizontal,
      fullWidth,
      fullHeight,
      divider,
      alignItems,
      justifyContent,
      children,
      forwardRef,
      classes,
      dataTestId
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const items = (0, _react.useMemo)(() => _react.Children.toArray(children).reduce((acc, item, index) => {
    if (index !== 0 && divider) {
      acc.push(_react.default.cloneElement(divider, {
        key: `${index}_divider`
      }));
    }
    acc.push(item);
    return acc;
  }, []), [children, divider, horizontal, size]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx.default)(className, classes.stack, classes[horizontal ? 'horizontal' : 'vertical'], classes[size], {
      [classes.fullWidth]: fullWidth,
      [classes.fullHeight]: fullHeight,
      [classes[`justifyContent__${justifyContent}`]]: justifyContent,
      [classes[`alignItems__${alignItems}`]]: alignItems
    }),
    ref: forwardRef,
    "data-testid": dataTestId
  }, props), items);
});

/*
 * There is issues in currently used version of the storybook
 * related to default props and jss/styledComponents:
 * https://github.com/storybookjs/storybook/issues/8279
 * https://github.com/storybookjs/storybook/issues/8361
 *
 * The problem should be soloved in newer versions of storybook.
 * Temporary workaround - to wrap whole styled component in
 * another react component and then define prop-types on it.
 */
const Stack = props => /*#__PURE__*/_react.default.createElement(StyledStack, props);
Stack.V = props => /*#__PURE__*/_react.default.createElement(Stack, (0, _extends2.default)({}, props, {
  horizontal: false
}));
Stack.H = props => /*#__PURE__*/_react.default.createElement(Stack, (0, _extends2.default)({}, props, {
  horizontal: true
}));
Stack.SIZE = _constants.SPACE_SIZE;
Stack.ALIGN_ITEMS = _constants2.ALIGN_ITEMS;
Stack.JUSTIFY_CONTENT = _constants2.JUSTIFY_CONTENT;
Stack.defaultProps = {
  size: Stack.SIZE.medium
};
var _default = exports.default = Stack;